import loadScriptAsync from '../loadScriptAsync'
import debug from '../console'
import {
  markConsentTiming,
  measureConsentTiming,
} from '../consent/consentTiming'
import { ensureUsOptOutSignal } from '../consent/usOptOutSignal'
import { LAUNCHPAD_WRAPPER_URL } from './adUrls'
const logger = debug.withTag('utils:preAYScripts')

let pending: Promise<void> | null = null

const load = async () => {
  // This must run before LaunchPad does; the shell may have preloaded it. The
  // package wrapper makes GPC/DNT authoritative in the CMP's __gpp/__uspapi
  // responses before AY can consume an allow-shaped vendor response.
  ensureUsOptOutSignal()
  markConsentTiming('cmp-request-start')
  /**
   * Launchpad carries the CMP, and LiveRamp is explicit that the CMP has to be up
   * before ATS and the consent-gated calls that depend on it, so this has to
   * settle before AY bootstraps.
   */
  await loadScriptAsync(
    'head',
    {
      src: LAUNCHPAD_WRAPPER_URL,
      key: 'liveramp',
    },
    { defer: true }
  ).catch((error) => {
    logger.warn(
      'Failed to load LiveRamp identity module, continuing without enhanced targeting',
      error
    )
  })
  markConsentTiming('cmp-request-settled')
  measureConsentTiming(
    'cmp-request',
    'cmp-request-start',
    'cmp-request-settled'
  )
}

/**
 * Memoized. Two plugins wait on this, and a second loadScriptAsync call for a
 * script that already failed attaches to the dead tag and never settles.
 */
export const preAYScripts = () => (pending ??= load())

export function resetPreAYScriptsForTests(): void {
  pending = null
}
